/**
 * @typedef {object} Props
 * @prop {boolean} hasWrapper
 * @prop {Function} wrapper
 * @prop {import("react").ReactNode} children
 */

/**
 * Ajoute de manière conditionnelle un wrapper autour d’un composant si le prop `hasWrapper` est à `true`.
 * Sinon, retourne juste le composant sans wrapper.
 * @param {Props} props
 */
function ConditionalWrapper(props) {
  const { hasWrapper, wrapper, children } = props;
  return hasWrapper ? wrapper(children) : children;
}

export default ConditionalWrapper;
